// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-editor {
  display: block;
}
.text-editor__textarea {
  display: block;
  border: 1px solid var(--g-color-line-generic);
  border-radius: 8px;
  overflow: hidden;
}
.text-editor__textarea-control {
  min-width: 600px;
  max-width: 80vw;
  min-height: 150px;
  max-height: 80vh;
  resize: both;
}
.text-editor__info {
  display: inline-flex;
  align-items: center;
  color: var(--g-color-text-secondary);
  line-height: 24px;
  margin-top: 4px;
}
.text-editor__info-text {
  margin-right: 4px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/TextEditor/TextEditor.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AACI;EACI,cAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;AACR;AAEI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAAR;AAGI;EACI,oBAAA;EACA,mBAAA;EACA,oCAAA;EACA,iBAAA;EACA,eAAA;AADR;AAII;EACI,iBAAA;AAFR","sourcesContent":[".text-editor {\n  display: block;\n}\n.text-editor__textarea {\n  display: block;\n  border: 1px solid var(--g-color-line-generic);\n  border-radius: 8px;\n  overflow: hidden;\n}\n.text-editor__textarea-control {\n  min-width: 600px;\n  max-width: 80vw;\n  min-height: 150px;\n  max-height: 80vh;\n  resize: both;\n}\n.text-editor__info {\n  display: inline-flex;\n  align-items: center;\n  color: var(--g-color-text-secondary);\n  line-height: 24px;\n  margin-top: 4px;\n}\n.text-editor__info-text {\n  margin-right: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
